import actionTypes from 'constants/eventbriteConstants';
import { fromJS } from 'immutable';

export const initialState = fromJS({
  initialized: false,
  isLoading: false,
  isAuthorized: false,
  isListLoading: false,
  availableEvents: [],
  isRedirecting: false,
});

export default function eventbriteReducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.EVENTBRITE_INITIALIZE:
      return state.set('isLoading', true)
        .set('initialized', true);
    case actionTypes.EVENTBRITE_AUTHORIZED:
      return state.set('isLoading', false)
        .set('isAuthorized', true);
    case actionTypes.EVENTBRITE_UNAUTHORIZED:
      return state.set('isLoading', false)
        .set('isAuthorized', false);
    case actionTypes.EVENTBRITE_DISCONNECTED:
      return state.set('isAuthorized', false);
    case actionTypes.FETCH_EVENTBRITE_EVENTS_REQUEST:
      return state.set('isListLoading', true);
    case actionTypes.FETCH_EVENTBRITE_EVENTS_SUCCESS:
      return state.set('isListLoading', false)
        .set('availableEvents', fromJS(action.payload));
    case actionTypes.FETCH_EVENTBRITE_EVENTS_FAILURE:
      return state.set('isListLoading', false);
    case actionTypes.FETCH_EVENTBRITE_EVENT_REQUEST:
      return state.set('isLoading', true);
    case actionTypes.FETCH_EVENTBRITE_EVENT_FAILURE:
    case actionTypes.FETCH_EVENTBRITE_EVENT_SUCCESS:
      return state.set('isLoading', false);
    case actionTypes.EVENTBRITE_REDIRECTING:
      return state.set('isRedirecting', true);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/eventbriteReducer.js